import React, { useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

const QRBarcodeScanner = () => {
  const [data, setData] = useState("No result"); 
  const [error, setError] = useState(null); 
  const [isScanning, setIsScanning] = useState(false); 

  const handleScan = (result) => {
    console.log(result)
    if (result) {
      setData(result.text); 
    }
  };

  const handleError = (err) => {
    console.error(err); 
    setError("Unable to scan the code. Please try again.");
  };

  const toggleScanning = () => {
    setIsScanning(!isScanning); 
    if (isScanning) {
      setData("No result"); 
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>QR & Barcode Scanner</h2>
      <button
        onClick={toggleScanning}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          marginBottom: "20px",
          cursor: "pointer",
        }}
      >
        {isScanning ? "Stop Scan" : "Start Scan"}
      </button>

      {isScanning && (
        <div style={{ width: "300px", height: "300px", margin: "auto" }}>
          <BarcodeScannerComponent
            onUpdate={(err, result) => {
              if (result) handleScan(result);
              if (err) handleError(err);
            }}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}
      {data && (
        <div style={{ marginTop: "20px" }}>
          <h3>Scanned Data:</h3>
          <p>{data}</p>
        </div>
      )}
    </div>
  );
};

export default QRBarcodeScanner;
